import { combineReducers } from 'redux';
import { ACTION } from './constants';

import schemeReducer from './Scheme/reducer';
import favoritesReducer from './Favorites/reducer';

let initialState = {
    list: {
        cards: [],
        meta: {},
        header: {},
        total: 0,
        apiResponse: false
    },
    search: {},
    filters: [],
    fundNavNifty: {},
    fundNavSensex: {},
    fundNavBanking: {},
    fundNavGold: {},
    fundNavNiftyNext50: {},
    fundNavNifty100: {},
    iNavData: {},
};

function productReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.GET_PRODUCT_LIST:
            return {
                ...state,
                list: {
                    cards: [...action.data.cards],
                    meta: action.meta,
                    header: action.data.header,
                    total: action.data.total,
                    apiResponse: true
                }
            };
        case ACTION.APPEND_PRODUCT_LIST:
            return {
                ...state,
                list: {
                    cards: [...state.list.cards, ...action.data.cards],
                    meta: action.data.meta,
                    header: action.data.header,
                    total: action.data.total,
                    apiResponse: true
                }
            };
        case ACTION.GET_PRODUCT_CARD_NAV_CONTENT:
            let name = action.data.navs[0].navType;
            return { ...state, iNavData: { ...state.iNavData, [name]: action.data.navs[0] } }
        case ACTION.GET_SEARCH_LIST:
            return {
                ...state,
                search: {
                    ...action.data,
                }
            };
        case ACTION.GET_PRODUCT_FILTERS:
            return { ...state, filters: action.data };

        case ACTION.POST_SUBSCRIBE_PRODUCT:
            return { ...state, subscribeResult: action.data };

        case ACTION.CLEAR_SUBSCRIBE_RESULT:
            return { ...state, subscribeResult: null };

        case ACTION.CLEAN_PRODUCT_LIST:
            return {
                ...state,
                list: {
                    cards: [],
                    meta: {},
                    total: 0,
                    apiResponse: false
                }
            };

        case "POST_SMALL_CASE":
            return { ...state, txnId: action.data.transactionId }
        //etf api
        case ACTION.GET_ETF:
            return { ...state, etfList: action.data };

        default:
            return state;
    }
}

export default combineReducers({
    productList: productReducer,
    scheme: schemeReducer,
    favorites: favoritesReducer,
});
